<template>
  <div class="ui-body">
    <!-- 01.主体容器 - 头部 Start -->
    <div class="ui-container-header">
      <!-- 01.01.主体容器 - 头部 - 标题 Start -->
      <h3 class="ui-container-header-title"><i class="ion-ios-arrow-forward"></i>{{ this.$route.meta.title }}</h3>
      <!-- 01.01.主体容器 - 头部 - 标题 End -->
      <!-- 01.02.主体容器 - 头部 - 副标题 Start -->
      <p class="ui-container-header-subtitle">{{ this.$route.meta.description }}</p>
      <!-- 01.02.主体容器 - 头部 - 副标题 End -->
    </div>
    <!-- 01.主体容器 - 头部 End -->

    <!-- 02.主体容器 - 内容 Start -->
    <div class="ui-container-content">
      <div class="ui-content">
        <!-- 02.03.主体容器 - 内容 - 普通面板 Start -->
        <el-form class="ui-container-form" ref="formContent" :model="formContent" :label-width="formWidth"
                 :label-position="formPosition" :rules="formRules">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="ui-form-panel">
                <h4>上级栏目</h4>
                <div class="ui-tree">
                  <div class="ui-tree-search">
                    <el-input placeholder="请输入搜索内容" v-model="searchValue"
                              clearable></el-input>
                  </div>
                  <div class="ui-tree-content">
                    <el-scrollbar>
                      <el-tree ref="tree" :data="tree_data" :props="treeConfig"
                               :highlight-current="true" :expand-on-click-node="false"
                               default-expand-all :filter-node-method="searchFilter"
                               @node-click="itemClick"></el-tree>
                    </el-scrollbar>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="18">
              <div class="ui-form-panel">
                <el-scrollbar>
                  <h4>{{
                      this.formContent.parent != 0 && this.formContent.parent != null ? `上级栏目--${selectItem.label}` : '新增或修改顶级栏目'
                    }}</h4>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="栏目标题" prop="title">
                        <el-input v-model="formContent.title"
                                  placeholder="请输入栏目标题"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="排序" prop="sort">
                        <el-input v-model="formContent.sort"
                                  placeholder="请输入排序"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="栏目链接" prop="link">
                        <el-input v-model="formContent.link"
                                  placeholder="请输入栏目链接"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-scrollbar>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <!-- 02.03.主体容器 - 内容 - 普通面板 End -->
      </div>
    </div>
    <!-- 02.主体容器 - 内容 End -->

    <!-- 03.主体容器 - 尾部 Start -->
    <div class="ui-container-footer ">
      <!-- 03.01.主体容器 - 尾部 - 按钮 Start -->
      <div class="ui-container-footer-group" v-if="$Permissions(['BasicsPatch','BasicsCreate'])">
        <el-button type="primary" @click="formSubmit"><i class="ion-ios-add-circle"></i>{{ htmlSubmit }}</el-button>
        <el-button @click="onReset"><i class="ion-ios-refresh-circle"></i>重置</el-button>
      </div>
      <!-- 03.01.主体容器 - 尾部 - 按钮 End -->
    </div>
    <!-- 03.主体容器 - 尾部 End -->
  </div>
</template>

<script>
export default {
  name: "add_item",
  data() {
    return {
      // 01.显示模式 ------------------------------------------------
      // 01.01.Html标题
      htmlTitle: this.$route.meta.title,
      // 01.02.Html描述
      htmlDescription: this.$route.meta.description,
      // 01.03.Html按钮标题
      htmlSubmit: "添加",
      // 02.Form 配置/数据集 ------------------------------------------------
      // 02.01.Form提交API地址
      formAPI: '/api/create/item/',
      // 02.01.Form配置 - 标题位置
      formPosition: 'top',
      // 02.01.Form配置 - 标题宽度
      formWidth: '130px',
      selectItem: {},
      // 02.02.Form数据集
      formContent: {
        parent: undefined,
        title: "",
        link: "",
        sort: 0
      },
      // 02.03.Form 验证
      formRules: {
        title: [
          {required: true, message: '请输入栏目标题', trigger: 'blur'}
        ],
      },
      // 03.树状框数据集 ------------------------------------------------
      // 03.01.栏目数组
      tree_data: [],
      // 03.02.树状框搜索框
      searchValue: '',
      // 03.03.树状框配置
      treeConfig: {
        children: 'children',
        label: 'label'
      },
    }
  },
  // 监控data中的数据变化
  watch: {
    // 01.树状框数据变化
    searchValue(val) {
      this.$refs.tree.filter(val)
    }
  },
  // 方法集合
  methods: {
    // 01.Form表单提交
    formSubmit() {
      this.$refs['formContent'].validate((valid) => {
        if (valid) {
          this.$api.post(this.formAPI, this.formContent).then((response) => {
            this.$message.success(response)
          })
        }
      })
    },
    // 02.重置Form表单
    onReset() {
      this.$refs['formContent'].resetFields()
    },
    // 03.获取Form数据
    getForm() {
      this.$api.get('/api/get/item-data/', {'id': this.$route.params.id}).then((response) => {
        this.formContent.parent = response.data[0].parent
        this.formContent.title = response.data[0].title
        this.formContent.link = response.data[0].link
        this.formContent.sort = response.data[0].sort
      })
    },
    // 04.获取Tree数据
    getTree() {
      this.$api.get('/api/get/item-tree/').then((response) => {
        this.tree_data = response.data
      })
    },
    // 05.树状框搜索
    searchFilter(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    // 05.点击获取上级栏目
    itemClick(value) {
      this.formContent.parent = value.id;
      this.tree_data.forEach(ele => {
        if (value.id === ele.id) {
          this.selectItem = ele;
          console.log(' this.selectItem', this.selectItem);
        }
      })
    }
  },
  // 生命周期 - 挂载完成
  mounted() {
    // 01.判断当前写入/修改状态
    if (this.$route.params.id) {
      // 01.01.修改状态
      this.formAPI = '/api/patch/item/?id=' + this.$route.params.id
      this.htmlSubmit = "修改"
      this.getForm()
    } else {
      // 01.02.写入状态
      this.formAPI = '/api/create/item/'
      this.htmlSubmit = "添加"
    }
    // 02.获取Tree数据
    this.getTree()
  },
}
</script>
